import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions, Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from '../../../../../../common/translation/translation.component';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import { validateEmail } from '../../../../../../../utils/validation.utils';
import {
    OR_RRF_TextArea as TextArea
    , ORFButton as Button
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , ORFDatePicker
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../../../common/file-attachment/file-attachment.component';
import Icons from '../../../../../../icon';
import { trueFalseToBoolean, convertToUtcDate } from '../../../../../../../utils/helpers.utils';
import DATEPICKER_OR from '../../../../../../common/custom-form/custom-date-picker.component'
import { ConfirmationNotificationModal } from '../../../../../../common/modal/confirmation-modal.component';
import { SUBMIT_REQUEST, SUBMIT_REQUEST_TITLE, MAX_LENGTH } from '../../../../../../../constants/external-constants';
import { NotificationModal } from '../../../../../../common/modal/notification-modal.component';
import { withRouter } from 'react-router-dom';

class NewCircuitBusinessForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showContactFormInfo:false,
            showConModal:false,
            show:false,
            message:'',
            error: false
        }
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    setNeedByDate = (v) => {
        this.props.onDateSelect(v);
    }

    submitRequest = () => {
        this.setState({showConModal:true})

    }

    handleConfirmationModal = async (buttonType) => {
        const { submitRequest, fetchRequestLogItems, uploadFile, saveOrderFile, createRequest } = this.props;

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { isUpdateRequest } = createRequest;

            this.setState({ isSaving: true });

            var success = await submitRequest();
            let resultMessage = success.Message;

            if (success.Success) {
                var res = await uploadFile(success.OrderId);
                if (res != null && res.Result) {
                    await saveOrderFile(success.OrderId, res.FileNames);
                }
                resultMessage = isUpdateRequest
                    ? this.toLocaleLanguage("order_has_been_updated")
                    : this.toLocaleLanguage("order_has_been_submitted");

                this.setState({ title: "Success" });
                this.props.hideRequestModal();
                fetchRequestLogItems(0);
            } else {
                this.setState({ title: "Error" });
                resultMessage = success.Message
                    ? success.Message
                    : this.toLocaleLanguage("order_save_error_message");
            }
            this.setState((prev) => ({
                showConModal: !prev.showConModal,
                show: true,
                isSaving: false,
                message: resultMessage,
            }));
        } else {
            this.setState({ showConModal: false });
        }
    };


    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleCloseNotif = () => {
        this.setState({ show: false, isSaving:false });
        if(this.state.title!=="Error")
        {            
            this.props.history.goBack();
        }
    }

    primarySecondaryId = (option, value) => {
        const selectedPrimarySecondaryId = option.length > 0 ? option.find(x => x.Value == value).Key : "";
        return selectedPrimarySecondaryId;
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    render() {
        const { showContactFormInfo } = this.state;
        const {
            //component props
            onClickCancel
            , prevAction
            //form
            , wirelineBusinessFormA
            , wirelineLocationFormA
            , wirelineSubscriptionFormA
            //reducer action
            , onApproverSelect
            , onGLCodeSelect
            , onCostCenterSelect
            , onDateSelect
            , fetchEmployeeByValue
            , fetchGLCodeByValue
            , fetchCostCenterByValue
            , onExpediteSelect
            , isUpdate
        } = this.props;
        const { employeeList, glCodeList, costCenterList, isUpdateRequest } = this.props.createRequest;
        const { purposeOfUseOptions, formSubmitted, primarySecondaryOptions } = this.props.newCircuitRequest;
        const { requestData } = this.props.requestDetail;
        const initialRequired = wirelineBusinessFormA.wireLineApproverId == 0
                                || wirelineBusinessFormA.wireLineGlCodeId == 0
                                || wirelineBusinessFormA.wireLineCostCenterId == 0
                                || wirelineBusinessFormA.purposeOfUseId == 0                                           
                                || (trueFalseToBoolean(wirelineBusinessFormA.expediteRequest) && wirelineBusinessFormA.businessJustification == '')
                                || formSubmitted
                                || !wirelineBusinessFormA.needByDate;
        
        const updateRequired = isUpdateRequest ? !(requestData.LocationAddress.CountryCode != wirelineLocationFormA.countryCode
            || (requestData.BillingAddress.LocationId != 0 ? requestData.BillingAddress.LocationId != wirelineLocationFormA.billingAddressId : requestData.BillingAddress.LocationId != 0)
            || requestData.LocationAddress.LocationId != wirelineLocationFormA.locationAddressId
            || requestData.DemarcLocation != wirelineLocationFormA.demarcLocation
            || (requestData.LocationP2P != null && requestData.LocationP2P != undefined ? requestData.LocationP2P.LocationId != wirelineLocationFormA.locationAddressPTPId : requestData.LocationP2P != null )
            || requestData.DemarcLocationPTP != wirelineLocationFormA.demarcLocationPTP
            || requestData.Subscription.VendorDetailId != wirelineSubscriptionFormA.vendorDetailId
            || requestData.Subscription.ItemUseId != wirelineSubscriptionFormA.itemUseId
            || requestData.Subscription.CircuitTypeId != wirelineSubscriptionFormA.circuitTypeId
            || (requestData.Subscription.SubCircuitTypeId != null ? requestData.Subscription.SubCircuitTypeId != wirelineSubscriptionFormA.subCircuitTypeId : requestData.Subscription.SubCircuitTypeId != null)
            || this.primarySecondaryId(primarySecondaryOptions, requestData.Subscription.PrimarySecondary) != wirelineSubscriptionFormA.primarySecondaryId
            || (requestData.Subscription.BtnId != null ? requestData.Subscription.BtnId != wirelineSubscriptionFormA.btnId : requestData.Subscription.BtnId != null)
            || requestData.Subscription.Mrc != wirelineSubscriptionFormA.mrc
            || requestData.Subscription.Nrc != wirelineSubscriptionFormA.nrc
            || requestData.Subscription.Mrc2 != wirelineSubscriptionFormA.mrc2
            || requestData.Subscription.Nrc2 != wirelineSubscriptionFormA.nrc2
            || requestData.WireLineApprover.EmployeeId != wirelineBusinessFormA.wireLineApproverId
            || requestData.BusinessWireline.CircuitCostAllocations.GLCodeID != wirelineBusinessFormA.wireLineGlCodeId
            || requestData.BusinessWireline.CircuitCostAllocations.CostCodeID != wirelineBusinessFormA.wireLineCostCenterId
            || convertToUtcDate(requestData.Order.NeedByDate, true, "DD MMM YYYY") != convertToUtcDate(wirelineBusinessFormA.needByDate, true, "DD MMM YYYY")
            || requestData.BusinessWireline.ExpediteRequest.toString() != wirelineBusinessFormA.expediteRequest
            || requestData.BusinessJustification.PurposeOfUseId != wirelineBusinessFormA.purposeOfUseId
            || requestData.BusinessJustification.BusinessJustification != wirelineBusinessFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation != wirelineBusinessFormA.additionalInformation
        ) : false ;
        const today = new Date()

        let tomorrow = new Date()

        tomorrow.setDate(today.getDate() + 1)

        const mindate = tomorrow;

        //mindate.setDate(mindate.getDay + 1)

        let expediteOptions = [
            {
                "Key": true,
                "Value": "Yes"
            },
            {
                "Key": false,
                "Value": "No"
            }
        ];
        return (
            <div>

                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal confirmation-blur-background notification-footer modal-text-bold'}
                />

                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={this.props.isUpdate ? SUBMIT_REQUEST.updateRequest : SUBMIT_REQUEST.submitRequest}
                    title={this.props.isUpdate ? SUBMIT_REQUEST_TITLE.updateRequest :SUBMIT_REQUEST_TITLE.submitRequest}
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal confirmation-blur-background modal-text-bold'}
                />

                <Form method="post" role="form"
                    model="wirelineBusinessFormA"
                    onSubmit={this.submitRequest}
                >
                    <div>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required custom-margin'>
                                <SearchSuggestions
                                    value={wirelineBusinessFormA.wireLineApprover}
                                    label={`${this.toLocaleLanguage('approver')}`}
                                    propDisplay={'Name'}
                                    options={employeeList.length > 0 ? employeeList : ''}
                                    onChangeAction={onApproverSelect}
                                    searchAction={fetchEmployeeByValue}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    errorMessage={this.toLocaleLanguage('error_user_not_exist')}
                                    haveError={this.haveError}
                                />
                            </Col>
                        </Row>
                        { 
                            showContactFormInfo &&
                            <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                                <Icons
                                    customClassName="icon-circle-plus"
                                    name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                    size="20px"
                                    containerClass="icon-circle-plus-container"
                                />
                                <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                            </div>
                        }
                        
                        {this.state.localToggle ?
                            <div className="local-list-container">
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                            value={wirelineBusinessFormA.localContactEmail}
                                            fieldProp='.localContactEmail'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                            value={wirelineBusinessFormA.localContactFullName}
                                            fieldProp='.localContactFullName'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                            value={wirelineBusinessFormA.localContactPhone}
                                            fieldProp='.localContactPhone'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                            </div>
                            : ""}

                         { 
                            showContactFormInfo &&
                            <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                                <Icons
                                    customClassName="icon-circle-plus"
                                    name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                    size="20px"
                                    containerClass="icon-circle-plus-container"
                                />
                                <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                            </div>
                         }
                       
                        {this.state.alterToggle ?
                            <div className="alter-list-container">
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                            value={wirelineBusinessFormA.altLocalContactEmail}
                                            fieldProp='.altLocalContactEmail'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('alt_local_contact_full_name')} *`}
                                            value={wirelineBusinessFormA.altLocalContactFullName}
                                            fieldProp='.altLocalContactFullName'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('alt_local_contact_phone_number')} *`}
                                            value={wirelineBusinessFormA.altLocalContactPhone}
                                            fieldProp='.altLocalContactPhone'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            : ""}
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required custom-margin'>
                                <SearchSuggestions
                                    value={wirelineBusinessFormA.wireLineGlCode}
                                    label={`${this.toLocaleLanguage('gl_code')}`}
                                    propDisplay={'Glcode'}
                                    options={glCodeList.length > 0 ? glCodeList : ''}
                                    onChangeAction={onGLCodeSelect}
                                    searchAction={fetchGLCodeByValue}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className="required custom-margin">
                                <SearchSuggestions
                                    value={wirelineBusinessFormA.wireLineCostCenter}
                                    label={`${this.toLocaleLanguage('cost_center')}`}
                                    propDisplay={'CostCenter'}
                                    options={costCenterList.length > 0 ? costCenterList : ''}
                                    onChangeAction={onCostCenterSelect}
                                    searchAction={fetchCostCenterByValue}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                />
                            </Col>
                        </Row>
                       
                        <Row>
                            <Col xs={6} md={6} lg={6} className="required">
                                <div className="date-picker-group">
                                    <DATEPICKER_OR 
                                        label={`${this.toLocaleLanguage('need_by_date')}`}
                                        placeholder="Select Date"
                                        startDate={wirelineBusinessFormA.needByDate ??  ""}
                                        selectedDate={(date) => this.props.FormChange("wirelineBusinessFormA.needByDate", date)} 
                                        requiredField={true}                                                                          
                                    />
                                </div>                      
                            </Col>

                            <Col xs={6} md={6} lg={6} className="required">
                                    <Select
                                        className="form-control"
                                        label={`${this.toLocaleLanguage('expedite_request')}`}
                                        options={expediteOptions}
                                        fieldProp='.expediteRequest'
                                        value={wirelineBusinessFormA.expediteRequest}
                                        onChangeAction={onExpediteSelect}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                    />
                            </Col>

                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className="required">
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('purpose_of_use')}`}
                                    options={purposeOfUseOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.purposeOfUseId'
                                    value={wirelineBusinessFormA.purposeOfUseId}                                   
                                />
                            </Col>
                        </Row>                        
                        <Row>
                            <Col xs={12} md={12} lg={12} className={`${trueFalseToBoolean(wirelineBusinessFormA.expediteRequest)? "required" : ""}`}>
                                <TextArea
                                    label={`${this.toLocaleLanguage('business_justification')}`}
                                    fieldProp='.businessJustification'
                                    value={wirelineBusinessFormA.businessJustification}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_500}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0
                                        || !trueFalseToBoolean(wirelineBusinessFormA.expediteRequest)
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={this.toLocaleLanguage('additional_information')}
                                    fieldProp='.additionalInformation'
                                    value={wirelineBusinessFormA.additionalInformation}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_1000}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3} md={3} lg={3}>
                                <FileAttachment isUpdate={isUpdateRequest} requestFileName={requestData.Order != undefined ? requestData.Order.OrderFileNames : null}/>
                            </Col>
                        </Row>
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('submit_request_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter (connect(
    state => {
        const { newCircuitRequest, createRequest, translation, requestDetail } = state;
        const { wirelineBusinessFormA, wirelineLocationFormA, wirelineSubscriptionFormA } = state.form;
        return {
            newCircuitRequest
            , wirelineBusinessFormA
            , wirelineLocationFormA
            , wirelineSubscriptionFormA
            , createRequest
            , requestDetail
            , ...translation
        };
    }
    , dispatch => ({
        ...bindActionCreators(
            Object.assign({}, newCircuitSubscriptionActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
            ),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
        
)(NewCircuitBusinessForm));